import DevelopmentHeader from './../components/developmentHeader';
import { connect } from 'react-redux';

export default connect(state => ({
    companyId: state.account.companyId,
}))(DevelopmentHeader);
